import {Modal, ModalProps} from './modal';

export function CompactModal(props: ModalProps) {
  return (
    <Modal
      preventCloseClick
      fullWidth
      maxWidth="sm"
      PaperProps={{sx: {maxWidth: '576px'}}}
      {...props}
    />
  );
}
